import React from "react";
import { Link } from "react-router-dom";

import { getRelatedArticles } from "../../data/articles";

import "./styles/relatedPosts.css";

const RelatedPosts = ({ slug }) => {
	const related = getRelatedArticles(slug, 3);
	if (!related.length) return null;

	return (
		<div className="related-posts">
			<div className="related-posts-heading">Keep reading</div>
			<div className="related-posts-list">
				{related.map((a) => (
					<Link
						className="related-post"
						to={`/article/${a.slug}`}
						key={a.slug}
					>
						<div className="related-post-title">{a.title}</div>
						<div className="related-post-tldr">
							{a.tldr || a.description}
						</div>
						<div className="related-post-meta">
							{a.readingTime} min read
						</div>
					</Link>
				))}
			</div>
		</div>
	);
};

export default RelatedPosts;
